import React from "react";
import { Col, Row } from "reactstrap";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import arrow from "../../assets/img/arrow.svg";
import arrowWhite from "../../assets/img/arrowWhite.svg";
import info from "../../assets/img/info.svg";
import infoWhite from "../../assets/img/infoWhite.svg";
import msg from "../../assets/img/msg.svg";
import msgWhite from "../../assets/img/msgWhite.svg";
import request from "../../assets/img/request.svg";
import requestWhite from "../../assets/img/requestWhite.svg";

const MenuPageRoutes = ({
  restaurantId,
  userId,
  userType,
  orderType,
  isHoliday,
}) => {
  const history = useHistory();
  const darkMode = useSelector((state) => state.global.darkMode);
  const pageRoutes = [
    {
      dark: request,
      light: requestWhite,
      title: "Request service",
      value: "table/request/tableNo",
      show: userId && !isHoliday?.isHoliday && orderType === "dinein",
    },
    {
      dark: msg,
      light: msgWhite,
      title: "Give Feedback",
      value: "feedback",
      show: !isHoliday?.isHoliday && userId,
    },
    {
      dark: info,
      light: infoWhite,
      title: "Info",
      value: "info",
      show: true,
    },
  ];

  const handleRouteClick = (route) => {
    if (route.title === "Request service") {
      history.push({
        pathname: `/${route.value}`,
        state: {
          restaurantID: restaurantId,
          customerID: userId,
        },
      });
    } else {
      history.push(`/${route.value}`);
    }
  };

  return (
    <>
      <hr className="restaurant__profile__divider" />
      {pageRoutes
        .filter((route) => route.show)
        .map((page, idx) => (
          <div key={idx}>
            <Row
              className="restaurant_profile__page_route cursor-pointer"
              onClick={() => handleRouteClick(page)}
            >
              <Col className="col-10 d-flex justify-content-start align-items-center">
                <img
                  src={darkMode ? page.light : page.dark}
                  className="icon mx-2"
                  alt="icon"
                />
                <p className="mb-0 restaurant__profile__name">{page.title}</p>
              </Col>
              <Col className="col-2 d-flex justify-content-end align-items-center">
                <img
                  src={darkMode ? arrowWhite : arrow}
                  className="arrow_icon"
                  alt="arrow_icon"
                />
              </Col>
            </Row>
            <hr className="restaurant__profile__divider" />
          </div>
        ))}
    </>
  );
};

export default MenuPageRoutes;
